export default {
  toolBox: {
    title: "Helpful Tip",
    text: "This profile can populate the following:",
    formsArray: [
      // Currently unsupported for 9141C
      // {
      //     formCommonName: "CW-1 PREVAILING WAGE",
      //     formGovName: "FORM ETA-9141C",
      //     sections: ["SECTION B"]
      // },
      // Currently unsupported for 9142C
      //   {
      //     formCommonName: "CW-1 LABOR CERTIFICATION",
      //     formGovName: "FORM ETA-9142C",
      //     sections: ["SECTION C"],
      //   },
      {
        formCommonName: "H-2A AGRICULTURAL CLEARANCE ORDER",
        formGovName: "FORM ETA-790",
        sections: ["SECTION II"],
      },
      {
        formCommonName: "H-2A TEMPORARY LABOR CERTIFICATION",
        formGovName: "FORM ETA-9142A",
        sections: ["SECTION C"],
      },
      {
        formCommonName: "H-2B | H-1B | PERM PREVAILING WAGE",
        formGovName: "FORM ETA-9141",
        sections: ["SECTION B"],
      },
      {
        formCommonName: "H-2B LABOR CERTIFICATION",
        formGovName: "FORM ETA-9142B",
        sections: ["SECTION D"],
      },
      {
        formCommonName: "PERM PERMANENT EMPLOYMENT CERTIFICATION",
        formGovName: "FORM ETA-9089",
        sections: ["SECTION B"],
      },
    ],
  },
};
